import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData, put } from "../../../services/apiService";
import { showSnackbar } from "../../snackbar/Snackbar.slice";

const GET_EXCHANGES = "exchanges/get";
const MODIFY_EXCHANGE = "exchanges/modify";

export const getExchanges = createAsyncThunk(
  GET_EXCHANGES,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, acquirerID, isoID, merchantID, acquirerName, page = 1, pageSize = 5 } = payload;
      const endpoint = `/merchant-exchanges`;
      const data = {
        version: "04.09.01",
        acquirerMerchantID: merchantID,
        acquirerID: acquirerID,
        isoID: isoID,
        page: page,
        pageSize: pageSize,
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerID,
      };

      const { data: response } = await fetchData({ endpoint, data, headers, token });
      return {
        exchanges: response.exchanges || [],
        page: response.page || page,
        pageSize: response.page_size || pageSize,
        totalRecords: response.total_records || (response.exchange ? response.exchange.length : 0),
      };
    } catch (error) {
      console.error("Error getting exchanges thunk:", error);
      dispatch(
        showSnackbar({ message: "Error getting exchanges data", severity: "error" })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const modifyExchangeStatus = createAsyncThunk(
  MODIFY_EXCHANGE,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        merchantID,
        exchangeCode,
        exchangeStatus,
        exchangeCatalogId,
        category,
        exchangeName,
        exchangeRowKey,
        acquirerId,
        acquirerName,
        onSuccess = false,
      } =
        payload;
      const endpoint = `/merchant-exchanges/status`;
      const newStatus = exchangeStatus === 'E'? 'D': 'E';
      const catalogIdNum = Number(exchangeCatalogId);
      const hasCatalogId = exchangeCatalogId != null && exchangeCatalogId !== "" && Number.isFinite(catalogIdNum);
      const data = {
        version: "04.09.01",
        acquirerMerchantID: merchantID,
        exchangeCode: exchangeCode,
        exchangeStatus: newStatus,
        ...(hasCatalogId ? { id: catalogIdNum } : {}),
        ...(category ? { category } : {}),
        ...(exchangeName && exchangeName !== "-" ? { exchangeName } : {}),
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };

      await put(endpoint, data, { headers });
      dispatch(
        showSnackbar({ message: `Exchange ${exchangeStatus === 'E' ? "deactivated" : "activated"} successfully`, severity: "success" })
      );
      if (onSuccess) onSuccess();
      return { exchangeCode, exchangeRowKey: exchangeRowKey || exchangeCode, newStatus };
    } catch (error) {
      console.error("Error modifying exchange status thunk:", error);
      dispatch(showSnackbar({ message: "Exchange modification failed", severity: "error" }));
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
